import { render, staticRenderFns } from "./RulesBar.vue?vue&type=template&id=54d37a3c&scoped=true"
import script from "./RulesBar.vue?vue&type=script&lang=js"
export * from "./RulesBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d37a3c",
  null
  
)

export default component.exports